// extracted by mini-css-extract-plugin
module.exports = {"root":"SideBar_root__wHJSJ","img":"SideBar_img__382g0","header":"SideBar_header__36IHp"};